import { Provider } from "react-redux";
import "./assets/styles/style.css";
import Main from "./components/Main";
import Nav from "./components/Nav";
import store from "./redux/store";

function App() {
  return (
    <>
      <Provider store={store}>
        <Nav />
        <Main />
      </Provider>
    </>
  );
}

export default App;
